import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";

export const getWomenJudiciaryTextApi = function* getWomenJudiciaryText(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = URLS.WOMEN_IN_JUDICIARY_TEXT
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//----------------------------------------------------------------------

export const getWomenInJudiciaryDataApi = function* getWomenInJudiciaryData(action) {
    
    yield put({ type: "SHOW_LOADER" });
    let path = action.path;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
        yield put({ type: "HIDE_LOADER" });
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

  //----------------------------------------------------------------------

  export const getWomenInJudiciaryGraphDataApi = function* getWomenInJudiciaryGraphData(action) {
    
    // yield put({ type: "SHOW_LOADER" });
    let path = action.path;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
        yield put({ type: "HIDE_LOADER" });
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

  //----------------------------------------------------------------------

  export const getOverAllDiversityDataApi = function* getOverAllDiversityData(action) {
    
    yield put({ type: "SHOW_LOADER" });
    let path = action.path;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
        yield put({ type: "HIDE_LOADER" });
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

  //----------------------------------------------------------------------

  export const getOverAllDiversityFaqApi = function* getOverAllDiversityFaq(action) {
    
    yield put({ type: "SHOW_LOADER" });
    let path = action.path;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
        yield put({ type: "HIDE_LOADER" });
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

  //----------------------------------------------------------------------

  export const getOverAllDiversityStatesListApi = function* getOverAllDiversityStatesList(action) {
    
    yield put({ type: "SHOW_LOADER" });
    let path = action.path;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
        yield put({ type: "HIDE_LOADER" });
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

  //----------------------------------------------------------------------


